import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { TaskDescriptionTip } from '../components/TaskDescriptionTip.tsx';
import ShowMeButton from '../components/ShowMeButton.tsx';
import { useActions } from '../services/index.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './linkWorkItems.messages.tsx';
import { TASK_LINK_WORK_ITEMS } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { openDeliveryTab, completeTaskAndContinue } = useActions();

	const showMeButtonClickHandler = useCallback(() => {
		openDeliveryTab();
		completeTaskAndContinue({ id: TASK_LINK_WORK_ITEMS });
	}, [openDeliveryTab, completeTaskAndContinue]);

	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionTip>{formatMessage(messages.tip)}</TaskDescriptionTip>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			<ShowMeButton onClick={showMeButtonClickHandler} />
		</TaskDescription>
	);
};

export const linkWorkItems = {
	id: TASK_LINK_WORK_ITEMS,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
